import * as wActs from './website-actions.js';
import * as wConst from '../consts/website-consts';

export function GetAgencyList() {
  return (dispatch,getState) => {
    let page = "1";
    page = wActs.getParameterByName("page");
    if(wActs.isNullOrEmpty(page)) {page = "1"; }
    dispatch({type: wConst.ACTION_FETCH_AGENCYLIST_PENDING, payload: false});
    let ref = wActs.GetReferer();
    let headers = {
      'X-Alt-Referer': ref,
    };

    let qInc = null;
    let qExc = null;


    let state = getState();
    let includes = "";
    let excludes = "";

    let query = `?pagesize=${wConst.FILTER_PAGESIZE}&page=${page}`;

    if (qInc != null) {
      includes += qInc;
      if (qExc != null) excludes += qExc;
    } else {
      let pth = state.Website.Page.Settings;
      if (typeof pth.Include !== "undefined") { includes += pth.Include; }
      if (typeof pth.Exclude !== "undefined") { excludes += pth.Exclude; }
    }

    if (!wActs.isNullOrEmpty(includes)) {
      query += "&include=" + includes;
    }
    if (!wActs.isNullOrEmpty(excludes)) {
      query += "&exclude=" + excludes;
    }


    fetch(`${wConst.ROOT_URL(state.Website.Settings.ApiUrl)}/agents${query}`, { headers: headers})
      .then(resp => resp.json())
      .then(function (data) {
        if (data.Code !== 200) {
          dispatch({type: wConst.ACTION_FETCH_AGENCYLIST_REJECTED, payload: data});
          dispatch(wActs.showWarning("WARN", data.Message));
        } else {
          dispatch({type: wConst.ACTION_FETCH_AGENCYLIST_FULLFILLED, payload: data});
        }
      }).catch(function (ex) {
      dispatch({ type: wConst.ACTION_FETCH_AGENCYLIST_REJECTED, payload: ex.toString() });
      dispatch(wActs.showWarning("WARN", ex.toString()));
    });
  }
}


export function GetAgencyProfile(id) {
  return (dispatch,getState) => {
    dispatch({type: wConst.ACTION_FETCH_AGENCYPROFILE_PENDING, payload: false});
    let ref = wActs.GetReferer();
    let headers = {
      'X-Alt-Referer': ref,
    };
    fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/agent/profile/${id}`, { headers: headers})
      .then(resp => resp.json())
      .then(function (data) {
        if (data.Code !== 200) {
          dispatch({type: wConst.ACTION_FETCH_AGENCYPROFILE_REJECTED, payload: data});
          dispatch(wActs.showWarning("WARN", data.Message));
        } else {
          dispatch({type: wConst.ACTION_FETCH_AGENCYPROFILE_FULLFILLED, payload: data});
        }
      }).catch(function (ex) {
      dispatch({ type: wConst.ACTION_FETCH_AGENCYPROFILE_REJECTED, payload: {Code: 500, Message: ex.toString()} });
      dispatch(wActs.showWarning("WARN", ex.toString()));
    });
  }
}

